import { render } from "./TicketFormInputs.vue?vue&type=template&id=0b7c3d06"
import script from "./TicketFormInputs.vue?vue&type=script&lang=js"
export * from "./TicketFormInputs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__